import { BreakpointProvider, setDefaultBreakpoints } from 'react-socks'

export const breakPoints = setDefaultBreakpoints([
  { xsmall: 0 }, // all mobile devices
  { small: 576 }, // mobile devices (not sure which one's this big)
  { medium: 900 }, // ipad, ipad pro, ipad mini, etc
  { large: 900 }, // smaller laptops
  { xlarge: 1200 }, // laptops and desktops
])

export const WebViewBreakPoint = ({ children }) => {
  return <BreakpointProvider> {children} </BreakpointProvider>
}
